<template>
    <v-row>
        <v-col cols="4">
            <PRO_Clase @selection-changed="handleSelectionChanged" />
        </v-col>
        <v-col cols="8">
            <PRO_Categorii :ClasaID="selectedRow" />
        </v-col>
    </v-row>
</template>

<script lang="ts">
import PRO_Categorii from './PRO_Categorii.vue';
import PRO_Clase from './PRO_Clase.vue';


export default {
    components: {
        PRO_Clase,
        PRO_Categorii

    },
    data() {
        return {
            selectedIndex: 0,
            selectedRow: null as any,

        };
    },
    methods: {
        handleSelectionChanged(selectedRow: any) {
            this.selectedRow = selectedRow.ID;

        },

    },
};
</script>

<style scoped>

</style>
